import { decorateFetch } from '../../fetch'
import cookies from 'js-cookie'

export enum SCMType {
  BITBUCKET = 'BITBUCKET',
  GITHUB = 'GITHUB',
  GITLAB = 'GITLAB'
}

export interface OnboardingServiceArgs {
  organizationUuid: string
  teamServerUrl: string
  destinationUrl: string
  scmType: SCMType
}

export interface OnboardingServiceResponse {
  scmInstallationUrl: string
}

export async function postOnboardingService({
  organizationUuid,
  teamServerUrl,
  destinationUrl,
  scmType
}: OnboardingServiceArgs): Promise<OnboardingServiceResponse> {
  const decoratedFetch = decorateFetch(fetch, cookies, location, null)
  const response = await decoratedFetch(
    `${destinationUrl}/onboarding/organizations/${organizationUuid}/install/${scmType}`,
    { method: 'POST', body: { teamServerUrl } }
  ).then((value) => value.json())

  return response
}
